<mode-format-dropdown-list
  [label]="'Axis labels'"
  [menuItems]="menuItems"
  [selected]="selected"
  [menuDisabled]="menuDisabled"
  (selectedChange)="selectItem($event)"
></mode-format-dropdown-list>
